var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoMessages = function SvgNoMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 435 208.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d6d5ec",
    stroke: "#7f85c0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M326.5 206.4H94.3c-5.6 0-10.1-4.5-10.1-10.1V57.5c0-5.6 4.5-10.1 10.1-10.1h232.3c5.6 0 10.1 4.5 10.1 10.1v138.8c0 5.6-4.6 10.1-10.2 10.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#7f85c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M332.8 49.8c-1.8-1.5-4.2-2.4-6.7-2.4H94.7c-2.6 0-4.9.9-6.7 2.4l122.4 77.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 336.7,
    cy: 47.4,
    r: 47.4,
    fill: "#dc3545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6d5ec",
    stroke: "#7f85c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M2.5 206.4h24m11.9 0h394.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336.7 21.2c15.7 0 16.5 19.6 14.9 31.2-1.1 7.9-5.9 15.7-14.9 15.4-9 .3-13.8-7.4-14.9-15.4-1.7-11.6-.8-31.2 14.9-31.2m0 40.5c9.5-.1 8.4-17.2 7.8-23.8-.6-4.8-2.3-10.6-7.8-10.6-5.6 0-7.2 5.8-7.8 10.6-.7 6.6-1.7 23.7 7.8 23.8"
  })));
};
export default SvgNoMessages;